import {
  SearchFilterType as FilterType,
  SearchFilter,
} from '@aibees/elephant/feature/search-filters/';
import { MixedFilter } from '@aibees/elephant/feature/search-filters/filters//mixed-filter';
import { AccordionFilter } from '@aibees/elephant/feature/search-filters/filters/accordion-filter';
import { AppliedFilters } from '@aibees/elephant/feature/search-filters/filters/applied-filters';
import { AutocompleteFilter } from '@aibees/elephant/feature/search-filters/filters/autocomplete-filter';
import { AutocompleteTreeFilter } from '@aibees/elephant/feature/search-filters/filters/autocomplete-tree-filter';
import { BulkInputFilter } from '@aibees/elephant/feature/search-filters/filters/bulk-input-filter';
import { ButtonGroupFilter } from '@aibees/elephant/feature/search-filters/filters/button-group-filter';
import { CheckListFilter } from '@aibees/elephant/feature/search-filters/filters/check-list-filter';
import { CheckboxGroupFilter } from '@aibees/elephant/feature/search-filters/filters/checkbox-group-filter';
import { CompanyIdsFilter } from '@aibees/elephant/feature/search-filters/filters/company-ids-filter';
import { DateRangePickerFilter } from '@aibees/elephant/feature/search-filters/filters/date-range-picker-filter';
import { DurationFilter } from '@aibees/elephant/feature/search-filters/filters/duration-filter';
import { EmployeeByDepartmentFilter } from '@aibees/elephant/feature/search-filters/filters/employee-by-department-filter';
import { NumberRangeFilter } from '@aibees/elephant/feature/search-filters/filters/number-range-filter';
import { RadioFilter } from '@aibees/elephant/feature/search-filters/filters/radio-filter';
import { RadioGroupFilter } from '@aibees/elephant/feature/search-filters/filters/radio-group-filter';
import { SectionTitle } from '@aibees/elephant/feature/search-filters/filters/section-title';
import { TextFieldFilter } from '@aibees/elephant/feature/search-filters/filters/text-field-filter';
import { TextFieldGroupFilter } from '@aibees/elephant/feature/search-filters/filters/text-field-group-filter';
import { AccordionGroupFilter } from '../filters/accordion-group-filter';
import { AccordionSectionFilter } from '../filters/accordion-section-filter';
import { CustomComponentFilter } from '../filters/custom-component-filter';
import { GroupWrapperFilter } from '../filters/group-wrapper-filter';
import { SwitchFilter } from '../filters/switch-filter';
import { TimeFrameFilter } from '../filters/time-frame-filter';

export const FILTER_INPUTS_REGISTRY = new Map<
  Partial<FilterType>,
  (props: SearchFilter) => any
>([
  [FilterType.BUTTON_GROUP, ButtonGroupFilter],
  [FilterType.CHECK_BOX_GROUP, CheckboxGroupFilter],
  [FilterType.RADIO_GROUP, RadioGroupFilter],
  [FilterType.CHECK_BOX, CheckListFilter],
  [FilterType.DATE_RANGE, DateRangePickerFilter],
  [FilterType.BULK, BulkInputFilter],
  [FilterType.NUMBER_RANGE, NumberRangeFilter],
  [FilterType.TEXT_FIELD_GROUP, TextFieldGroupFilter],
  [FilterType.TEXT_FIELD, TextFieldFilter],
  [FilterType.RADIO, RadioFilter],
  [FilterType.SWITCH, SwitchFilter],
  [FilterType.ACCORDION, AccordionFilter],
  [FilterType.TITLE, SectionTitle],
  [FilterType.APPLIED_FILTERS, AppliedFilters],
  [FilterType.NONE, AppliedFilters],
  [FilterType.DURATION, DurationFilter],
  [FilterType.EMPLOYEE_BY_DEPARTMENT, EmployeeByDepartmentFilter],
  [FilterType.MIXED, MixedFilter],
  [FilterType.COMPANY_IDS, CompanyIdsFilter],
  [FilterType.TIME_FRAME, TimeFrameFilter],
  [FilterType.ACCORDION_GROUP, AccordionGroupFilter],
  [FilterType.ACCORDION_SECTION, AccordionSectionFilter],
  [FilterType.CUSTOM_SELECT, AutocompleteFilter],
  [FilterType.CUSTOM_SELECT_TREE, AutocompleteTreeFilter],
  [FilterType.GROUP_WRAPPER, GroupWrapperFilter],
  [FilterType.CUSTOM_COMPONENT, CustomComponentFilter],
]);
